import createIcon from '../../createIcon';

/**
 * @component @name BarChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCA5SDRWMjBIOFY5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIwIDEzSDE2VjIwSDIwVjEzWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0IDRIMTBWMjBIMTRWNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BarChart = createIcon('BarChart', [
  ['path', { d: 'M8 9H4V20H8V9Z', key: '1l3a01' }],
  ['path', { d: 'M20 13H16V20H20V13Z', key: '1g3o4p' }],
  ['path', { d: 'M14 4H10V20H14V4Z', key: 'j7vwnk' }],
]);

export default BarChart;
